import { Redirect, useLocation } from "wouter";
import { ProtocolManager } from "./ProtocolManager";
import { ProjectDetailPage, ProjectManager } from "./ProjectManager";
import { NftManager } from "./NftManager";
import { TraitDetailPage, TraitManager } from "./TraitManager";
import { VaultManager } from "./VaultManager";
import { OperationsManager } from "./OperationsManager";
import { TokenManager } from "./TokenManager";
import { FeaturedPartnerManager } from "./FeaturedPartnerManager";

export function OuraAdminPage() {
  const [location] = useLocation();
  const projectDetailMatch = location.match(/^\/tweeto-admin\/oura\/projects\/(\d+)$/);
  const traitDetailMatch = location.match(/^\/tweeto-admin\/oura\/traits\/(.+)$/);

  if (location.endsWith("/protocol")) return <ProtocolManager />;
  if (projectDetailMatch) return <ProjectDetailPage projectId={Number(projectDetailMatch[1])} />;
  if (location.endsWith("/projects")) return <ProjectManager />;
  if (location.endsWith("/nfts")) return <NftManager />;
  if (traitDetailMatch) return <TraitDetailPage collection={decodeURIComponent(traitDetailMatch[1])} />;
  if (location.endsWith("/traits")) return <TraitManager />;
  if (location.endsWith("/vault")) return <VaultManager />;
  if (location.endsWith("/tokens")) return <TokenManager />;
  if (location.endsWith("/featured-partners")) return <FeaturedPartnerManager />;
  if (location.endsWith("/history")) return <OperationsManager />;

  return <Redirect to="/tweeto-admin/oura/protocol" />;
}
